export const replaceBraces = (str: string): string => {
  return str.replace(/{|}|\[|\]/g, "").trim();
};

export const convertCollectionToObj = (
  collection: string
): { [key: string]: string } => {
  const splitArr: Array<string> = collection.split(",");

  return splitArr.reduce((obj: { [key: string]: string }, item: string) => {
    const splitItem = item.split("=");
    const key = replaceBraces(splitItem[0]);
    obj[key] = replaceBraces(splitItem[1]);

    return obj;
  }, {});
};

export const removeEmptyProperties = (obj: {
  [key: string]: string | number | null;
}) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
};

export const getContentDispositionFileName = (
  contentDisposition: string
): string => {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);

  if (matches != null && matches[1]) {
    const removeEncoding = matches[1].replace("UTF-8", "");
    return decodeURIComponent(removeEncoding.replace(/['"]/g, ""));
  }
};

export const decodeJSON = (jsonStr: string) => {
  const jsonObj = JSON.parse(jsonStr);

  const decodeObj = (obj: any): any => {
    if (typeof obj === "string") {
      return decodeURIComponent(obj.replace(/\+/g, " "));
    } else if (Array.isArray(obj)) {
      return obj.map(decodeObj);
    } else if (typeof obj === "object" && obj !== null) {
      const decodedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          decodedObj[key] = decodeObj(obj[key]);
        }
      }
      return decodedObj;
    }
    return obj;
  };

  return decodeObj(jsonObj);
};

export const replaceExtraSpaces = (str = ""): string =>
  str.replace(/\s{2,}/g, " ").trim();

export const extractString = (str = "", amountOfCharacters: number): string =>
  str.substring(0, amountOfCharacters);

export const isObjectEmpty = (obj = {}): boolean => !Object.keys(obj).length;

export const scrollToTop = (): void => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

export const openWindow = (link: string): void => {
  window.open(link, "_blank", "noopener, noreferrer");
};
